import { constantTree } from "../../../core/events/ConstantTree";

export const myCompanyAccountTree = constantTree({
  MyCompanyAccount: {
    Action: {
      Click: ""
    },
    Company: {
      InvoiceDetails: {
        Save: ""
      }
    },
    Employees: {
      Get: "",
      Add: "",
      Edit: "",
      Delete: "",
      SetStatus: ""
    },
    Cards: {
      Remove: ""
    }
  }
})
